import React from 'react';
import { useKioskState } from '../../../context/Kiosk/kiosk';
import { OutdoorKeyDropRoutes } from './Outdoor/OutdoorKeyDropRoutes';
import { OutdoorKeyDropRoutesProps } from './Outdoor/OutdoorKeyDropRoutes.types';
import { KeyDropRoutes } from './KeyDrop/KeyDropRoutes';
import { KeyDropRoutesProps } from './KeyDrop/KeyDropRoutes.types';
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';

export interface KeyDropIndexProps extends KeyDropRoutesProps, OutdoorKeyDropRoutesProps { }

export const KeyDropIndex: React.FC<KeyDropIndexProps> = ({ onProceed, onSkip }) => {
    const { kioskType } = useKioskState();

    return kioskType === 'outdoor' || !isElectron() ? <OutdoorKeyDropRoutes onProceed={onProceed} /> : <KeyDropRoutes onProceed={onProceed} onSkip={onSkip} />;
};